import Vue from 'vue'
import VCharts from 'v-charts'
Vue.use(VCharts)
export default {
    name: 'tpl_11',

    props: {
        data: Object
    },

    created() {
        let data = this.data;

        data.data.lists.map((v, i) => {
            
            // zongping
            if (v.zongping && v.zongping.defen) {
                v.chartSettings = {
                    limitShowNum: 2,
                    dimension: 'a',
                    metrics: 'b',
                    labelLine: {
                        show: false
                    }
                }
                v.chartData = {
                    columns: ['a', 'b'],
                    rows: [
                        { 'a': ' ', 'b': 100 - Number(v.zongping.defen) },
                        { 'a': '', 'b': Number(v.zongping.defen) },
                    ]
                }
            }

            if (v.zbzk) {
                v.zbzkArray = []
                v.zbzk.weidu.map((val, index) => {
                    v.zbzkArray.push(val)
                })
            }

            if (v.xlzb) {
                v.xlzbData = { columns: ['i'], rows: [{ 'i': '' }, { 'i': '' }, { 'i': '' }] };
                v.xlzb.weidu.map((val, index) => {
                    v.xlzbData.columns.push(val.title)
                    v.xlzbData.rows[0][val.title] = val.defen
                    v.xlzbData.rows[1][val.title] = val.zongfen
                    v.xlzbData.rows[2][val.title] = 100
                })
            }

            if (v.lagzb) {
                v.lagzbData = { columns: ['i'], rows: [{ 'i': '' }, { 'i': '' }, { 'i': '' }] };
                v.lagzb.weidu.map((val, index) => {
                    v.lagzbData.columns.push(val.title)
                    v.lagzbData.rows[0][val.title] = val.defen
                    v.lagzbData.rows[1][val.title] = val.zongfen
                    v.lagzbData.rows[2][val.title] = 100
                })
            }

            if (v.qtzb) {
                v.qtzbData = { columns: ['i'], rows: [{ 'i': '' }, { 'i': '' }, { 'i': '' }] };
                v.qtzb.weidu.map((val, index) => {
                    v.qtzbData.columns.push(val.title)
                    v.qtzbData.rows[0][val.title] = val.defen
                    v.qtzbData.rows[1][val.title] = val.zongfen
                    v.qtzbData.rows[2][val.title] = 100
                })
            }
        })
        this.items = data.data.lists
    },

    data() {
        return {
            items: [],

            colors: ['#5ec2b5', '#d7eae8', '#eaeaea'],

            chartData: {
                columns: ['i', 'a'],
                rows: [
                    { 'i': '', 'a': '' },
                    { 'i': '', 'a': 100 }
                ]
            },


            chartSettingsGauge: {
                seriesMap: {
                    w: {
                        radius: '94%',
                        startAngle: 180,
                        endAngle: 0,
                        splitNumber: 4,
                        axisLine: {
                            lineStyle: {
                                color: [[1, '#5ec2b5'], [1, '#d7eae8']],
                                width: 25
                            }
                        },
                        splitLine: {
                            lineStyle: {
                                color: '#fff',
                                width: 1
                            }
                        },
                        axisTick: {
                            length: 12,
                        },
                        axisLabel: {
                            textStyle: {
                                fontWeight: 'bolder',
                                color: '#5ec2b5',
                                shadowColor: '#5ec2b5',
                                shadowBlur: 10
                            }
                        },
                        detail: {
                            fontSize: 16,
                            fontWeight: 'bold'
                        }
                    }
                },
            },
            chartDataGauge: {
                columns: ['type', 'value'],
                rows: [
                    { type: 'w', value: 40 }
                ]
            },

            chartSettings: {
                areaStyle: {
                    opacity: .4
                },
                label: {
                    show: true,
                    fontSize: 10
                }
            }
        }
    }

}